const CATEGORIES = [
  { label: '韩漫恋爱', icon: 'ri-heart-line', count: '856部', color: 'primary' },
  { label: '韩漫奇幻', icon: 'ri-magic-line', count: '642部', color: 'accent' },
  { label: '日漫热血', icon: 'ri-fire-line', count: '729部', color: 'primary' },
  { label: '日漫搞笑', icon: 'ri-emotion-laugh-line', count: '513部', color: 'accent' },
  { label: '国漫古风', icon: 'ri-landscape-line', count: '387部', color: 'primary' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '294部', color: 'accent' },
  { label: '治愈日常', icon: 'ri-cup-line', count: '436部', color: 'primary' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫画分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            按类型和地区快速浏览，精准定位你感兴趣的漫画世界
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {CATEGORIES.map((cat) => (
            <a
              key={cat.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${
                cat.color === 'primary'
                  ? 'bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50'
                  : 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
              } transition-colors duration-300`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.label}</span>
              <span className="text-xs text-foreground-500">{cat.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}